import { bindDevToolboxScenarioIdListener } from "@/lib/devToolbox/bindScenarioListener";
import { isDevToolboxEnabled } from "@/lib/devToolbox/isDevToolboxEnabled";
import type { DevToolboxScenarioId } from "@/lib/devToolbox/types";
import {
  DEV_TOOLBOX_MOCK_ITEM_ID,
  resolveDevBuyerFlowFromScenario,
  shouldOpenChatWarningForDevFlow,
  shouldOpenPaymentModalForDevFlow,
  type DevBuyerFlowParam,
} from "@/lib/devToolbox/itemDetailMocks";

export { DEV_TOOLBOX_MOCK_ITEM_ID } from "@/lib/devToolbox/itemDetailMocks";

export function isDevToolboxMockItem(itemId: string): boolean {
  return isDevToolboxEnabled() && itemId === DEV_TOOLBOX_MOCK_ITEM_ID;
}

export function resolveDevBuyerFlowForItem(
  itemId: string,
  urlFlowParam: DevBuyerFlowParam | null,
): DevBuyerFlowParam | null {
  if (urlFlowParam) return urlFlowParam;
  if (!isDevToolboxMockItem(itemId)) return null;
  return null;
}

export function applyDevToolboxScenario(
  scenarioId: DevToolboxScenarioId | null,
): {
  showPaymentModal: boolean;
  showChatWarningModal: boolean;
} {
  const flow = resolveDevBuyerFlowFromScenario(scenarioId);
  return {
    showPaymentModal: shouldOpenPaymentModalForDevFlow(flow),
    showChatWarningModal: shouldOpenChatWarningForDevFlow(flow),
  };
}

export type ItemDetailDevToolboxContext = {
  setShowPaymentModal: (open: boolean) => void;
  setShowChatWarningModal: (open: boolean) => void;
};

export function subscribeItemDetailDevToolboxAdapter(
  isDevMockItem: boolean,
  context: ItemDetailDevToolboxContext,
): () => void {
  if (!isDevToolboxEnabled() || !isDevMockItem) return () => {};

  return bindDevToolboxScenarioIdListener((scenarioId) => {
    const { showPaymentModal, showChatWarningModal } =
      applyDevToolboxScenario(scenarioId);
    context.setShowPaymentModal(showPaymentModal);
    context.setShowChatWarningModal(showChatWarningModal);
  });
}
